export default {
  created: 'Created',
  toActive: 'Soon active',
  activated: 'Activated',
  toCancele: 'Soon canceled',
  canceledBySystem: 'Canceled by system',
  canceledByUser: 'Canceled by user',
  renewed: 'Paid',
  renewFailed: 'Payment failed'
}